import EcoBanner, { EcoBannerProps } from 'eco-design/sections/eco-banner-card';
import EcoLink from 'eco-design/base/eco-link';
import styles from './index.module.scss';
import { useLang } from '@/i18n';
import EcoEmail, { EmailFieldsType } from 'eco-design/elements/eco-email';
import moment from 'moment';
import { useGlobal } from '@/utils/useGlobal';
import EcoIconArrow from 'eco-design-micro/icons/eco-icon-arrow';
import { useRouter } from 'next/router';
import { useMemo } from 'react';
import { useProductStore } from '../../../../ProductProvider';
import { IPageStatus } from '../../../../config/IPageStatus';

const contactListIds = {
    jp: '503090051',
    eu: '1585617461',
    uk: '1372111406',
    de: '356112763',
    fr: '1615613479',
    it: '1004671813',
    es: '1212554384',
};
function FooterA() {
    const { t } = useLang('powerBank.BannerA');
    const { locale = 'us' } = useRouter();
    const { getSystemTime } = useGlobal();
    const systemTime = getSystemTime();
    const date = moment(systemTime).format('YYYY-MM-DD') as any;
    const termsHtml: {
        [key: string]: any;
    } = {
        jp: 'EcoFlow の<a href="https://account.ecoflow.com/agreement/ja-jp/PrivacyPolicy.html" target="_blank" rel="noopener noreferrer" onclick="event.stopPropagation()">プライバシーポリシー</a>と<a href="https://account.ecoflow.com/agreement/ja-jp/TermsOfUse.html" target="_blank" rel="noopener noreferrer" onclick="event.stopPropagation()">利用規約</a>に同意します。',
    };
    const fields = useMemo(() => {
        const EU_Fields: EmailFieldsType[] = [
            { type: 'single', id: '31', value: 1, overwrite: true },
            { type: 'multiple', id: '7596', value: [49], overwrite: false },
            { type: 'multiple', id: '9690', value: [12], overwrite: false },
        ];
        switch (locale) {
            case 'eu':
                return [{ type: 'single', id: '4427', value: 1, overwrite: true }, ...EU_Fields];
            case 'uk':
                return [{ type: 'single', id: '4430', value: 1, overwrite: true }, ...EU_Fields];
            case 'de':
                return [{ type: 'single', id: '4425', value: 1, overwrite: true }, ...EU_Fields];
            case 'fr':
                return [{ type: 'single', id: '4428', value: 1, overwrite: true }, ...EU_Fields];
            case 'it':
                return [{ type: 'single', id: '4429', value: 1, overwrite: true }, ...EU_Fields];
            case 'es':
                return [{ type: 'single', id: '4426', value: 1, overwrite: true }, ...EU_Fields];
            case 'jp':
                return [
                    { type: 'single', id: '4431', value: 1, overwrite: true },
                    { type: 'single', id: '31', value: 1, overwrite: false },
                    { type: 'multiple', id: '12713', value: [2], overwrite: false },
                    // 订阅日期
                    {
                        id: '12712',
                        type: 'text',
                        value: date,
                        overwrite: false,
                    },
                ];
            default:
                return [{ type: 'single', id: '4427', value: 1, overwrite: true }, ...EU_Fields];
        }
    }, [locale]);

    return (
        <div className="comp-EcoEmail">
            <EcoEmail
                contactListId={[contactListIds[locale as keyof typeof contactListIds] ?? contactListIds.eu]}
                source="WEB_NEW_PRODUCT_SUB"
                termsHtml={termsHtml[locale]}
                fields={fields}
                tipsObj={{ placeholder: t('emailPlaceholder') }}
                subscribeData={{
                    sector_name: t('title'),
                    entry_position: 1,
                }}
            />
        </div>
    );
}

export default function Comp() {
    const { locale = 'us' } = useRouter();

    const { t } = useLang('powerBank.BannerA');
    const IS_EU = ['eu', 'uk', 'de', 'fr', 'it', 'es'];
    const IS_buy = ['jp', 'us', 'ca', 'ph'];
    const IS_PH = ['ph'].includes(locale);
    const { pageStatus } = useProductStore();
    const dataA: EcoBannerProps = {
        layout: 'top-center',
        pc: IS_PH
            ? 'https://websiteoss.ecoflow.com/upload/image/1762504562030/pc_kv.jpg'
            : 'https://websiteoss.ecoflow.com/upload/image/1748590450957/pc_kv.jpg',
        h5: IS_PH
            ? 'https://websiteoss.ecoflow.com/upload/image/1762504521466/m_kv.jpg'
            : 'https://websiteoss.ecoflow.com/upload/image/1748590545211/m_kv%2015.31.14.jpg',
        label: t('label'),
        title: t('title'),
        desc: t('desc'),
        theme: 'black',

        lChildren: (
            <span onClick={() => {}}>
                {/* {t('btn1')} */}
                {IS_buy.includes(locale) ? t('btn1') : pageStatus === IPageStatus.statusA ? t('Prepare_btn') : t('btn1')}
                <EcoIconArrow />
            </span>
        ),
        lHref: IS_buy.includes(locale)
            ? '#rapid-C'
            : `https://${locale}.ecoflow.com/collections/power-bank?sort_by=best-selling&filter.p.m.custom.filter_series=RAPID`,
        lType: 'text',
        lDataLayer: {
            event: 'uaEvent',
            event_name: 'buy',
            product_name: t('title'),
            position: 'rapid-power-bank',
            __btn_id1: 'BannerA .__btn_l',
            __btn_id2: IS_buy.includes(locale)
                ? '#rapid-C'
                : `https://${locale}.ecoflow.com/collections/power-bank?sort_by=best-selling&filter.p.m.custom.filter_series=RAPID`,
            __btn_type: 'href',
        },
        rDataLayer: {
            event: 'uaEvent',
            event_name: 'video',
            title_name: t('title'),
            position: 'rapid-power-bank',
            __btn_id1: 'BannerA .__btn_r',
            __btn_id2: 'bannerBtnR',
            __btn_type: 'common',
        },
        rChildren: <EcoLink>{t('btn2')}</EcoLink>,
        rHref: 'https://www.youtube.com/embed/RDyHaLHHgmQ?si=b6FwXYyIyGosJX8f',
        rType: 'text',
        rBtnIsYouToBe: true,
        childrenB: locale === 'jp' && <FooterA />,
    };
    return (
        <div className={`${styles.comp} GtmModuleData-section BannerA`} data-section-id={'BannerA'}>
            <EcoBanner {...dataA} />
        </div>
    );
}
